export default __webpack_public_path__ + "bc0bc86f082800038558030a97e7d370.png";